import { useMutation, useQueryClient } from '@tanstack/react-query';

import { VesselProduct } from '../../../../types/VesselProduct';
import { useToasts } from '../../../cdl/Toast/useToasts';
import { createVesselProduct } from '../../../common/api/clients/vessel.api';
import { queries } from '../../../common/api/queryKeys/queries';
import { translate } from '../../../common/helpers/translate.helper';

interface CreateVesselProductParams {
    vesselProduct: VesselProduct;
}

export const useCreateVesselProduct = (vesselId: string) => {
    const queryClient = useQueryClient();
    const { addToast, addErrorToast } = useToasts();

    return useMutation({
        mutationFn: ({ vesselProduct }: CreateVesselProductParams) => createVesselProduct({ vesselId, vesselProduct }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: queries.vessels.detail(vesselId)._ctx.products.queryKey,
            });
            addToast(translate('vessel.products.toasts.addSuccess'));
        },
        onError: () => {
            addErrorToast(translate('vessel.products.toasts.addError'));
        },
    });
};
